<template>
    <BaseTooltip open-on-click side="top" :side-offset="8" content-class="max-w-80 p-3 text-left shadow-lg" :trigger-aria-label="triggerAriaLabel">
        <template #trigger>
            <BaseButton theme="tertiary" size="sm" icon-only class="shrink-0" :aria-label="triggerAriaLabel">
                <i class="bi bi-info-circle text-base" aria-hidden="true"></i>
            </BaseButton>
        </template>
        <template #content>
            <p v-if="regeneration" class="body-small">
                You already have a Collaboration Profile. Clicking Regenerate will replace your current profile with a new one based on these Perspective results.
            </p>
            <p v-else class="body-small">
                A shareable summary of how you work best. Sharing it helps teammates collaborate with you more effectively and gives Nadia the context to provide more personalized
                coaching.
            </p>
        </template>
    </BaseTooltip>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import { computed } from "vue";

const { regeneration = false } = defineProps<{ regeneration?: boolean }>();

const triggerAriaLabel = computed(() => (regeneration ? "What happens when I regenerate my Collaboration Profile?" : "What is a Collaboration Profile?"));
</script>
